import depositsWithdrawalsContent from "./content/deposits-and-withdrawals.json";

export const depositsWithdrawalsMock = {
  name: "deposits-and-withdrawals",
  layoutType: 1,
  areasList: [
    {
      id: "deposits-and-withdrawals-1",
      name: "deposits-and-withdrawals-content",
      componentName: "Comp:DepositsWithdrawalsPage",
      content: JSON.stringify(depositsWithdrawalsContent),
    },
  ],
};
